import { render } from "./PageButton.vue?vue&type=template&id=1e30536f&scoped=true"
import script from "./PageButton.vue?vue&type=script&lang=js"
export * from "./PageButton.vue?vue&type=script&lang=js"

import "./PageButton.vue?vue&type=style&index=0&id=1e30536f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e30536f"]])

export default __exports__